import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import privacybg from '../assets/images/privacy.jpg';

function Privacy(){

    useEffect(() => {
          document.title = "DCode | Privacy policy";
        }, []);
   
    return(
        <div>
            <Hero bgimg={privacybg} content="Your privacy matters to us. This Privacy Policy explains how DCode collects, uses, and protects your personal information when you use our platform." title="Privacy Policy"/>
                <section id="faq">
      <div className="container">
       <h1 className="faq-h1" style={{fontSize:"24PX", textAlign:"left"}}>
        Privacy Policy - DCode
       </h1>
       
            
            <p className="eula-p">
                We, in this document, refer to Designite, the company with website addresses <a className="eula-link" href="https://www.designite-tools.com">https://www.designite-tools.com</a> and <a className="eula-link" href="https://www.dcodehub.com">https://www.dcodehub.com</a>. The term "product" or "software product" refers to tools and online platforms, such as DCode, developed by Designite. In this Privacy Policy, we describe the type of data, including personal data (collectively, "data"), that we collect from you when you use the website mentioned above and Designite's product, and how we use and disclose that data.
            </p>
           
            <h5 className="eula-h5">
                What personal data do we collect?
            </h5>

            <p className="eula-p">
                <strong>
                    Email address:
                </strong> We may collect your email address in the following situations:
                <ul>
                    <li>
                        When you register and create an account on our website.
                    </li>
                     <li>
                        When you apply for an academic license through Designite’s website.
                    </li>
                     <li>
                      When you subscribe to our newsletter (optional).
                    </li>

                </ul>
            </p>

            <h5 className="eula-h5">
                Product Behavior and Usage Patterns
            </h5>

            <p className="eula-p">
                Designite may collect data related to how users interact with our products, including usage patterns and behavioral insights. We may also store metadata and code quality analysis results obtained during the use of our tools. However, we do not store the source code of any analyzed software system.
            </p>

            <h5 className="eula-h5">
                Embedded Content from Other Websites
            </h5>

            <p className="eula-p">
                Our website may include embedded content (e.g., videos, images, articles). Such embedded content behaves as if the visitor has accessed the source website directly. These external websites may collect data about you, use cookies, include third-party tracking, and monitor your interactions with the embedded content — especially if you are logged into those external platforms.
            </p>

            <h5 className="eula-h5">
                Why Do We Collect This Information?
            </h5>

            <p className="eula-p">
         <strong>
                Platform Functionality: 
            </strong> The data we collect enables our platform to function as intended and ensures a smooth user experience.
            </p>

            <p className="eula-p">
         <strong>
               Product Improvement:
            </strong> We collect usage data to better understand how our products are used. This helps us identify trends, improve performance, and enhance the overall user experience without linking the data to specific individuals or organizations.
            </p>

            <p className="eula-p">
         <strong>
               Research:
            </strong> Collected data may be used to conduct software engineering research aimed at advancing the field. Any data shared through research papers or presentations is aggregated and fully anonymized.
            </p>

            <p className="eula-p">
         <strong>
               Product Promotion:
            </strong> We may use the email addresses you provide to share updates about our product, new features, or related offerings. You can opt out of promotional communications at any time.
            </p>

            <h5 className="eula-h5">
                Who do we share your data with?
            </h5>

            <p className="eula-p">
                We do not share your data with any third party.
            </p>

            <h5 className="eula-h5">
                How long do we retain your data?
            </h5>

            <p className="eula-p">
                We may retain the collected data indefinitely.
            </p>

            <h5 className="eula-h5">
                What rights do you have over your data?
            </h5>

            <p className="eula-p">
                You may unsubscribe from our mailing list anytime. The product behavior and usage data can also be opted out at any time.
            </p>

            <h5 className="eula-h5">
                Contact
            </h5>

            <p className="eula-p">
                If you have any questions or concerns, please get in touch with us at <a className="eula-link" href="mailto:contact@designite-tools.com">contact@designite-tools.com</a>.
            </p>
            
            <hr className="privacy-hr"></hr>
             <p style={{marginTop:"20px"}}>
                Effective Date: July 25, 2025
            </p>
           
            
      </div>
   
    </section>
            <Footer />
        </div>
    )
}

export default Privacy;